import type {
  ApiSuccess,
  AuditChangeEntry,
  AuditLoginEntry,
  AuditQuery,
  AuditViewEntry,
} from '@todo/shared';
import { getPaged } from './client';

/** Typed wrappers around /api/audit (ADMIN / SUPER_ADMIN only - a 403 for
 *  anyone else is expected, and the page never renders for them anyway). */
export const auditApi = {
  changes(query: AuditQuery = {}): Promise<ApiSuccess<AuditChangeEntry[]>> {
    return getPaged<AuditChangeEntry[]>('/audit/changes', query as Record<string, unknown>);
  },

  views(query: AuditQuery = {}): Promise<ApiSuccess<AuditViewEntry[]>> {
    return getPaged<AuditViewEntry[]>('/audit/views', query as Record<string, unknown>);
  },

  logins(query: AuditQuery = {}): Promise<ApiSuccess<AuditLoginEntry[]>> {
    return getPaged<AuditLoginEntry[]>('/audit/logins', query as Record<string, unknown>);
  },
};
